import { Link } from "react-router-dom";
import { categories, friendLinks } from "@/mocks/streams";

export default function Footer() {
  return (
    <footer className="relative mt-16 overflow-hidden border-t border-background-200/70 bg-background-100">
      <div className="pointer-events-none absolute -top-24 left-1/3 h-56 w-56 rounded-full bg-primary-500/10 blur-3xl" />
      <div className="relative w-full px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <Link to="/" className="flex items-center gap-2">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-live-line text-xl"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">有因直播</span>
            </Link>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-500">
              有因直播是面向广大网络用户的综合直播平台，汇聚游戏、娱乐、生活等多元内容，让每一位主播与观众都能被看见。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {["ri-wechat-line", "ri-weibo-line", "ri-bilibili-line", "ri-youtube-line"].map((icon) => (
                <span
                  key={icon}
                  className="w-9 h-9 flex items-center justify-center rounded-md border border-background-200 text-foreground-400 transition-colors hover:border-primary-400 hover:text-primary-500"
                >
                  <i className={`${icon} text-lg`}></i>
                </span>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-foreground-900">直播分类</h3>
            <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.id}`}
                    className="text-sm text-foreground-500 transition-colors hover:text-primary-500"
                  >
                    {cat.name}直播
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-foreground-900">关于平台</h3>
            <ul className="mt-4 space-y-2">
              <li>
                <Link to="/about" className="text-sm text-foreground-500 transition-colors hover:text-primary-500">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-foreground-500 transition-colors hover:text-primary-500">
                  联系我们
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-sm text-foreground-500 transition-colors hover:text-primary-500">
                  搜索直播
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-500 transition-colors hover:text-primary-500">
                  主播招募
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-500 transition-colors hover:text-primary-500">
                  隐私政策
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-foreground-900">友情链接</h3>
            <ul className="mt-4 space-y-2">
              {friendLinks.map((link) => (
                <li key={link}>
                  <span className="cursor-pointer text-sm text-foreground-500 transition-colors hover:text-primary-500">
                    {link}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-200/70 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-400">© 2026 有因直播 YouYin Live. 保留所有权利。</p>
          <p className="text-xs text-foreground-400">
            本网站为前端演示版本，直播画面与弹幕聊天均为界面演示，不包含真实视频流与实时通信。
          </p>
        </div>
      </div>
    </footer>
  );
}